module.exports = __webpack_public_path__ + "static/media/user6.b75fa4e4.png";